<template>
    <div class="expected-report-dashboard">
        <div v-for="(item, idx) in listPreGoalDefault" :key="idx" class="card card-target p-3 mb-2 d-flex flex-column justify-content-between h-100" >
            <div v-if="listGoal[item]" class="h-100 d-flex flex-column justify-content-between align-items-start">
                <div class="d-flex justify-content-end align-items-center" style="width: 100%">
                    <el-tooltip :content="getTitleTooltip(dateByKey[item]?.tooltip)" placement="top">
                        <span class="text-muted">{{ `${listGoal[item] ? "Tổng mục tiêu " : item === 'pre_day' ? 'Kết quả' : "Tổng mục tiêu "} ${dateByKey[item]?.date ?? ''}`  }}</span>
                    </el-tooltip>
                </div>
                <div class="mt-2 mb-2">
                    <p class="target-title mb-1"> <span
                        :class="{'text-danger': listGoal[item]?.customer_new < listGoal[item]?.target_customer_new , 'text-success': listGoal[item]?.customer_new >= listGoal[item]?.target_customer_new}">{{ listGoal[item]?.customer_new }}</span> /<span>{{ listGoal[item]?.target_customer_new }} </span> <small>KH mới</small>
                    </p>

                    <p class="target-title mb-1"> <span
                        :class="{'text-danger': listGoal[item]?.customer_2A < listGoal[item]?.target_customer_2A , 'text-success': listGoal[item]?.customer_2A >= listGoal[item]?.target_customer_2A}">{{ listGoal[item]?.customer_2A }}</span> /<span>{{ listGoal[item]?.target_customer_2A }} </span> <small>KH có lịch hẹn</small>
                    </p>

                    <p class="target-title mb-1"> <span
                        :class="{'text-danger': listGoal[item]?.schedule_number < listGoal[item]?.target_schedule_number , 'text-success': listGoal[item]?.schedule_number >= listGoal[item]?.target_schedule_number}">{{ listGoal[item]?.schedule_number | formatVNDNoPrefix }}</span>/<span>{{ listGoal[item]?.target_schedule_number }}</span> <small>Lịch Tư Vấn</small>
                    </p>

                    <p class="target-title mb-1"> <span
                        :class="{'text-danger': listGoal[item]?.goal_amount < listGoal[item]?.target_amount , 'text-success': listGoal[item]?.goal_amount >= listGoal[item]?.target_amount}">{{ listGoal[item]?.schedule_number | formatVNDNoPrefix }}</span>/<span>{{ listGoal[item]?.target_schedule_number }}</span> <small>Hợp đồng mới</small>
                    </p>

                    <p class="target-title mb-1"><span
                        :class="{'text-danger': listGoal[item]?.goal_amount < listGoal[item]?.target_amount , 'text-success': listGoal[item]?.goal_amount >= listGoal[item]?.target_amount}">
                    {{ listGoal[item]?.goal_amount | formatVNDNoPrefix }}</span>/<span>{{ listGoal[item]?.target_amount | formatVNDNoPrefix }}</span>
                        <small>Doanh số</small>
                    </p >
                </div>
            </div>
            <div v-else>
                <div class="d-flex justify-content-end">
                    <el-tooltip :content="getTitleTooltip(dateByKey[item]?.tooltip)" placement="top">
                        <span class="text-muted">{{ `${listGoal[item] ? "Tổng mục tiêu " : item === 'pre_day' ? 'Kết quả mục tiêu' : "Tổng mục tiêu "} ${dateByKey[item]?.date ?? ''}`  }}</span>
                    </el-tooltip>
                </div>
                <div class="text-center mt-4 mb-4">
                    <p class="target-title mt-1 pt-2 m-0">Cá nhân, Đội nhóm tại Văn Phòng chưa nhập mục tiêu</p>
                </div>
            </div>
        </div>
        <div class="text-center">
            <router-link
                class="text-right bold text-decoration-underline"
                :to="{ name: 'sales-input'}"
                style="text-decoration: unset"
                title="Xem chi tiết"
            >
                Xem chi tiết
            </router-link>
        </div>

    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import moment from "moment-timezone";
import dialogHandleGoal from "./dialogHandleGoal.vue";

export default {
    name: "ExpectedReportDashboard",
    components: {
        dialogHandleGoal,
    },
    props: {
        listGoal: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    data() {
        return {
            nextDay: moment().add(1, "day").format("DD/MM/YYYY"),
            is_edit: "",
            dialogTarget: false,
            form: {
                targetScheduleNumber: "",
                targetCustomerNew: "",
                targetAmount: "",
                typeTarget: "",
            },
            listPreGoalDefault: ['pre_day', 'day', 'week', 'month'],
            dateByKey: {
                'pre_day': {
                    'date': this.$moment().subtract(1, 'day').format('DD-MM-YYYY'),
                    'title': 'mục tiêu hôm qua',
                    'tooltip': `Ngày ${this.$moment().subtract(1, 'day').format('DD-MM-YYYY')}`,
                    'goal_type': 0,
                },
                'day': {
                    'date': this.$moment().format('DD-MM-YYYY'),
                    'title': 'mục tiêu ngày',
                    'tooltip': `Ngày ${this.$moment().format('DD-MM-YYYY')}`,
                    'goal_type': 0,
                },
                'week': {
                    'date': `tuần ${this.$moment().format('W')}`,
                    'title': 'mục tiêu tuần',
                    'tooltip': `Từ ${this.$moment().startOf('week').format('DD-MM-YYYY')} đến ${this.$moment().endOf('week').format('DD-MM-YYYY')}`,
                    'goal_type': 1,
                },
                'month': {
                    'date': `tháng ${this.$moment().format('MM')}`,
                    'title': 'mục tiêu tháng',
                    'tooltip': `Tháng ${this.$moment().format('MM')}`,
                    'goal_type': 2,
                },
            }
        };
    },
    mounted() {
    },
    methods: {
        getTitleTooltip(tooltip) {
            let title = `Tổng mục tiêu của cá nhân, đội nhóm tại `;
            if (this.keyAccount === 4) {
                title += 'văn phòng'
            }
            if (this.keyAccount === 5) {
                title += 'khu vực'
            }
            if (this.keyAccount === 6) {
                title += 'vùng'
            }
            if (this.keyAccount === 7) {
                title += 'công ty'
            }
            return `${title} ${tooltip}`
        },
        handleShowDialogTarget(item, type, type_target) {
            this.is_edit = type === "edit" ? "Sửa" : "Nhập";
            if (type == "edit") {
                if (this.listGoal[item.type]) {
                    this.form = {
                        id: this.listGoal[item.type].id,
                        targetScheduleNumber: this.listGoal[item.type].target_schedule_number || "",
                        targetCustomerNew: this.listGoal[item.type].target_customer_new || "",
                        targetAmount: this.listGoal[item.type].target_amount
                            ? this.listGoal[item.type]?.target_amount.toLocaleString("vi-VN")
                            : "",
                        typeTarget: item.id,
                    };
                }
            } else {
                this.form = {
                    typeTarget: item.id,
                };
            }

            this.typeTarget = type_target;
            this.dialogTarget = true;
        },

        close() {
            this.dialogTarget = false;
        },

        emitGoal() {
            this.$emit("reload");
        },
    },
    computed: {
        ...mapState({
            errors: (state) => state.auth.errors,
        }),
        ...mapGetters(["currentUser", "keyAccount"]),
    },
};
</script>

<style scoped>
label {
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: rgba(0, 0, 0, 1);
}

#dashboard-leader .text-muted {
    font-family: SVN-Gilroy;
    font-weight: 400;
    font-size: 10px;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: left;
}
.expected-report-dashboard .card, .result-dashboard .card{
    height: auto !important;
}
</style>
